/**
 * The small square a code file's row starts with, lettered by its extension
 * (RFC 0277 S12, the demo's compact style). A glance at the column says which
 * rows are TypeScript and which are config, without reading the names.
 */

const BADGES: Record<string, [color: string, text: string]> = {
  ts: ['#1f6feb', 'TS'],
  tsx: ['#1f6feb', 'TS'],
  js: ['#b8a200', 'JS'],
  jsx: ['#b8a200', 'JS'],
  mjs: ['#b8a200', 'JS'],
  cjs: ['#b8a200', 'JS'],
  json: ['#8250df', '{}'],
  md: ['#6e7681', 'M'],
  css: ['#db61a2', '#'],
  html: ['#e34c26', '<>'],
  rs: ['#dea584', 'RS'],
  swift: ['#f05138', 'SW'],
  sh: ['#2ea043', '$'],
  yml: ['#cb171e', 'Y'],
  yaml: ['#cb171e', 'Y'],
  toml: ['#9c4221', 'T'],
}

const PLAIN: [string, string] = ['#6e7681', '']

export function badgeFor(name: string): [color: string, text: string] {
  const dot = name.lastIndexOf('.')
  if (dot <= 0) return PLAIN
  return BADGES[name.slice(dot + 1).toLowerCase()] ?? PLAIN
}

export function FileBadge({ name }: { name: string }) {
  const [color, text] = badgeFor(name)
  return (
    <span
      aria-hidden
      className="grid size-3.5 place-items-center rounded-[3px] font-bold font-mono text-[8px] leading-none"
      style={{ background: `${color}33`, color }}
    >
      {text}
    </span>
  )
}
